import personImg from "../../images/person.png";

const data = [
  {
    id: 1,
    image: personImg,
    name: "Mohamed Ali",
    JobTitle: "Web Developer",
    category: "WebDeveloper",
  },
  {
    id: 2,
    image: personImg,
    name: "Mohamed Ali",
    JobTitle: "Web Developer",
    category: "WebDeveloper",
  },
  {
    id: 3,
    image: personImg,
    name: "Mohamed Ali",
    JobTitle: "Mobile Developer",
    category: "MobileDeveloper",
  },
  {
    id: 4,
    image: personImg,
    name: "Mohamed Ali",
    JobTitle: "Mobile Developer",
    category: "MobileDeveloper",
  },
  {
    id: 5,
    image: personImg,
    name: "Mohamed Ali",
    JobTitle: "Front End",
    category: "FrontEnd",
  },
  {
    id: 6,
    image: personImg,
    name: "Mohamed Ali",
    JobTitle: "Front End",
    category: "FrontEnd",
  },
  {
    id: 7,
    image: personImg,
    name: "Mohamed Ali",
    JobTitle: "manager",
    category: "manager",
  },
  {
    id: 8,
    image: personImg,
    name: "Mohamed Ali",
    JobTitle: "Date Base",
    category: "DateBase",
  },
  {
    id: 9,
    image: personImg,
    name: "Mohamed Ali",
    JobTitle: "Date Base",
    category: "DateBase",
  },
];

export default data;
